import dayjs, { Dayjs } from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { DateRange } from '@mui/x-date-pickers-pro'
dayjs.extend(quarterOfYear)
dayjs.extend(utc)
dayjs.extend(timezone)

export const ACTIVATE_COMPANY_LOGO = 'https://s3.amazonaws.com/activate.com/Activate-01.png'
export const ACTIVATE_COMPANY_LOGO_WHITE = 'https://s3.amazonaws.com/activate.com/Activate-02.png'

export const STAR_OPTIONS = [
  { label: 'All Comments', value: 0 },
  { label: '5 Star', value: 5 },
  { label: '4 Star', value: 4 },
  { label: '3 Star', value: 3 },
  { label: '2 Star', value: 2 },
  { label: '1 Star', value: 1 },
]

export const COLOR_MAP: { [key in string]: { color: string } } = {
  Score5: { color: '#4BCF5D' },
  Score4: { color: '#FEE934' },
  Score3: { color: '#F8C636' },
  Score2: { color: '#FF8000' },
  Score1: { color: '#E30613' },
}

export const PERIOD_OPTIONS: IOption[] = [
  { label: 'Today', value: 'Today' },
  { label: 'WTD', value: 'WTD' },
  { label: 'MTD', value: 'MTD' },
  { label: 'Last 7 Days', value: '7-Day' },
  { label: 'Last 30 Days', value: '30-Day' },
  { label: 'Last 60 Days', value: '60-Day' },
  { label: 'Last 90 Days', value: '90-Day' },
  { label: 'Last 12 Months', value: '1-Year' },
  { label: 'YTD', value: 'YearToDate' },
  { label: 'Last 18 Months', value: '18-Month' },
  { label: 'Last 24 Months', value: '24-Month' },
]
export const DEFAULT_PERIOD_LAST_YEAR = PERIOD_OPTIONS.find((item) => item.value === '1-Year') as IOption
export const DEFAULT_PERIOD_YEAR_TO_DATE = PERIOD_OPTIONS.find((item) => item.value === 'YearToDate') as IOption
export const DEFAULT_PERIOD_TODAY = PERIOD_OPTIONS.find((item) => item.value === 'Today') as IOption
export const DEFAULT_DATE_RANGE_TODAY: DateRange<Dayjs> = [dayjs().startOf('day'), dayjs().endOf('day')]

export const DEFAULT_DATE_RANGE_WTD: DateRange<Dayjs> = [dayjs().startOf('week').startOf('day'), dayjs().endOf('day')]
export const DEFAULT_DATE_RANGE_LAST_7: DateRange<Dayjs> = [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')]
export const DEFAULT_DATE_RANGE_LAST_YEAR: DateRange<Dayjs> = [
  dayjs().subtract(12, 'month').day(1).hour(0).minute(0).second(0),
  dayjs().hour(23).minute(59).second(59),
]
export const DEFAULT_DATE_LAST_30: DateRange<Dayjs> = [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')]
export const DEFAULT_DATE_RANGE_YTD: DateRange<Dayjs> = [
  dayjs().startOf('year'),
  dayjs().hour(23).minute(59).second(59),
]
export const PERIOD_OPTIONS2 = [{ label: 'YTD', value: 'YearToDate' }]
export const VIEWS = [
  {
    label: 'Today',
    value: 'Today',
    range: DEFAULT_DATE_RANGE_TODAY,
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
    range: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
  },
  {
    label: 'This week',
    value: 'This week',
    range: DEFAULT_DATE_RANGE_WTD,
  },
  {
    label: 'Last Week',
    value: 'Last Week',
    range: [
      dayjs().subtract(1, 'week').startOf('week').startOf('day'),
      dayjs().subtract(1, 'week').endOf('week').endOf('day'),
    ],
  },
  {
    label: 'WTD',
    value: 'WTD',
    range: DEFAULT_DATE_RANGE_WTD,
  },
  {
    label: 'This Month',
    value: 'This Month',
    range: [dayjs().startOf('month').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last Month',
    value: 'Last Month',
    range: [
      dayjs().subtract(1, 'month').startOf('month').startOf('day'),
      dayjs().subtract(1, 'month').endOf('month').endOf('day'),
    ],
  },
  {
    label: 'MTD',
    value: 'MTD',
    range: [dayjs().startOf('month').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 7 Days',
    value: 'Last 7 Days',
    range: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 30 Days',
    value: 'Last 30 Days',
    range: DEFAULT_DATE_LAST_30,
  },
  {
    label: 'Last 60 Days',
    value: 'Last 60 Days',
    range: [dayjs().subtract(59, 'day').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 90 Days',
    value: 'Last 90 Days',
    range: [dayjs().subtract(89, 'day').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'This Quarter',
    value: 'This Quarter',
    range: [dayjs().startOf('quarter').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last Quarter',
    value: 'Last Quarter',
    range: [
      dayjs().subtract(1, 'quarter').startOf('quarter').startOf('day'),
      dayjs().subtract(1, 'quarter').endOf('quarter').endOf('day'),
    ],
  },
  {
    label: 'QTD',
    value: 'QTD',
    range: [dayjs().startOf('quarter').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 12 Months',
    value: 'Last 12 Months',
    range: [dayjs().subtract(12, 'month').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'YTD',
    value: 'YTD',
    range: DEFAULT_DATE_RANGE_YTD,
  },
  {
    label: 'Last 18 Months',
    value: 'Last 18 Months',
    range: [dayjs().subtract(18, 'month').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 24 Months',
    value: 'Last 24 Months',
    range: [dayjs().subtract(24, 'month').startOf('day'), dayjs().endOf('day')],
  },
]
